/**
 * @fileoverview AxiosConfig.js - main application wrapper.
 * 
 * This module sets up api object as an interface to axios.
 * 
 * @module AxiosConfig.js
 * @version 1.0.0
 * @author Mark Pearce
 * @license Proprietary
 * 
 * Copyright (c) 2025 Silkstone Technology Limited. All rights reserved.
 * 
 * This software is proprietary and confidential. You are not permitted to:
 * - Use, copy, modify, or distribute this software, in whole or in part, without 
 *   written permission from the author or rights holder.
 * - Reverse engineer, decompile, or disassemble the software.
 * - License, sublicense, or otherwise distribute the software without the express 
 *   written consent of the copyright holder.
 * 
 * This software is provided "as-is," without any express or implied warranty. The copyright 
 * holder is not liable for any damage or loss arising from the use of this software.
 * 
 * @requires 
 * 
 * @example
 */

import axios from 'axios';


const api = axios.create({
  baseURL: 'https://vps-85931059.vps.ovh.ca:5051',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
